import script from "./DashboardVue.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardVue.vue?vue&type=script&setup=true&lang=js"

import "./DashboardVue.vue?vue&type=style&index=0&id=4d5f5806&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d5f5806"]])

export default __exports__